<template>
<vx-card>

<div class="vx-row" >
        <div class="vx-col lg:w-1/6 md:w-1/4 sm:w-1/2 w-full">
            <label class="text-sm opacity-75">{{$t('DateFrom')}}</label>
            <datepicker :language="languages[language]" :placeholder="$t('SelectDate')" v-model="SearchParam.DateFrom"></datepicker>
        </div>
        <div class="vx-col lg:w-1/6 md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">{{$t('DateTo')}}</label>
          <datepicker :language="languages[language]" :placeholder="$t('SelectDate')" v-model="SearchParam.DateTo"></datepicker>
        </div>
        <div class="vx-col lg:w-1/6 md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">{{$t('AccountNo')}}</label>
          <vs-input icon-pack="feather" icon="icon-user" v-model="SearchParam.AccountNo" class="w-full"  name="AccountNo" />
        </div>
        <div class="vx-col lg:w-1/6 md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">{{$t('TransactionStatus')}}</label>
          <v-select class="w-full" v-model="transactionFilter" :reduce="item => item.value"  :options="Object.values($t('transactionOptions'))" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
        </div>
</div>
<div class="vx-row">  
        <div class="vx-col p-4 lg:w-1/6 md:w-1/4 sm:w-1/1 w-full">
          <vs-button color="success" type="filled" icon-pack="feather" icon="icon-search" @click="GetData">{{$t('Search')}}</vs-button>
        </div>     
</div>

<div id="tab-customer-transaction-list">
    <div class="mt-base">
      <grid-view-handler  v-if="usersData && usersData.length > 0"
        :usersData="usersData"
        :columnDefs="getColumnDefs"
        :ColStatus="ColStatus"
        :cookieName="paramCookieName"
        :FloatingFilter="false"
        :searchQuery="SearchQuery"
        :isAutoColumunDef="false">
      </grid-view-handler>
    </div>
</div>

</vx-card>
</template>

<script>
import GridViewHandler from '@/views/components/grid/GridViewHandler'
import moduleTransactionMng from '@/store/transaction-mng/moduleTransactionMng.js'
import Datepicker from 'vuejs-datepicker'
import * as lang from 'vuejs-datepicker/src/locale'
import vSelect from 'vue-select'


export default {
  components: {
    GridViewHandler,
    Datepicker,
    vSelect
  },
  data () {
    return {
      language: 'tr',
      languages: lang,
      data_local: null,
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      transactionFilter:-1,
      providerMethodFilter:-1,
      columnDefs: [],
      ColStatus: [],
      paramCookieName: 'CustomerTransactionsList',
      SearchQuery: '',
      SearchParam:{
        DateTo: null,
        DateFrom: null,
        customerId: '',
        AccountNo: '',
        ProviderMethodFilter:[]
      }
    }
  },
  methods:{
    fetch_transaction_data () {
      this.$store.dispatch('TransactionMng/getTransactionsByCustomerId', this.$store.state.AppActiveUser.customerId)
        .then(res => { 
          console.info(res.data)
          this.data_local = res.data
        })
        .catch(err => {
          console.error(err) 
        })
    },
    GetAllTransaction () {
      if (this.SearchParam.DateFrom === null) {
        const d = new Date(Date.now())
        this.SearchParam.DateFrom = `${ d.getFullYear() }-${  (`0${d.getMonth()}`).slice(-2)  }-${ (`0${  d.getDate()}`).slice(-2)  }`
        this.SearchParam.DateTo = `${ d.getFullYear() }-${  (`0${d.getMonth() + 1}`).slice(-2)  }-${ (`0${  d.getDate()}`).slice(-2)  }`
      }
      if (this.SearchParam.DateFrom.toString().length > 11) {
        const s = this.SearchParam.DateFrom

        this.SearchParam.DateFrom = `${ s.getFullYear() }-${  (`0${s.getMonth() + 1}`).slice(-2)  }-${ (`0${  s.getDate()}`).slice(-2)  }`
      }
      if (this.SearchParam.DateTo.toString().length > 11) {
        const e = this.SearchParam.DateTo

        this.SearchParam.DateTo = `${ e.getFullYear() }-${  (`0${e.getMonth() + 1}`).slice(-2)  }-${ (`0${  e.getDate()}`).slice(-2)  }`
      }
      this.SearchParam.customerId = this.$store.state.AppActiveUser.customerId

      console.error(this.SearchParam)

      this.$store.dispatch('TransactionMng/fetchGetAllTransaction', this.SearchParam)
        .then((res) => {
          console.info(res.data)
          this.data_local = res.data
          // this.$refs.filterCard.toggleContent()
          // this.$refs.filterCard.removeRefreshAnimation()
          this.SearchParam.ProviderMethodFilter = []
        })
        .catch(err => { 
          console.error(err)
          // this.$refs.filterCard.removeRefreshAnimation()
        })
    },
    GetData () {
      //this.$refs.filterCard.loadingCard()
      this.SearchParam.transactionFilter = this.transactionFilter

      if (this.providerMethodFilter.length === undefined || this.providerMethodFilter.length === 0) { 
        this.SearchParam.ProviderMethodFilter.push(-1) 
      } else { 
        this.SearchParam.ProviderMethodFilter = this.providerMethodFilter 
      }

      this.GetAllTransaction()
    }
  },
  computed: {
    getColumnDefs () {
      return [
        {
          headerName: this.$t('Id'),
          i18n:'Id',
          field: 'id',
          width: 70,
          hide: false
        },
        {
          headerName: 'Crm Id',
          field: 'customerId',
          width: 70,
          hide: true
        },
        {
          headerName: this.$t('AccountId'),
          field: 'account',
          width: 110,
          hide: false,
          cellRendererFramework: 'genericCellRendererContent'
        },
        {
          headerName: this.$t('Amount'),
          field: 'amount',
          width: 100,
          hide: false,
          textColor: 'amount',
          valueFormatter: currencyFormatterWithDollar,
          cellRendererFramework: 'genericCellRendererContent'
          // cellRendererFramework: 'cellRendererAmount'
        },
        {
          headerName: this.$t('Type'),
          field: 'transactionTypeId',
          width: 150,
          hide: false,
          contentType: 'chip',
          contentOptions: window.getEnumTransactionTypes(),
          cellRendererFramework: 'genericCellRendererContent'
        },
        {
          headerName: this.$t('Status'),
          field: 'providerStatus',
          width: 110,
          hide: false,
          contentType: 'chip',
          contentOptions: window.getEnumTransactionStatuses(),
          cellRendererFramework: 'genericCellRendererContent'          
          // cellRendererFramework: 'cellRendererTransactionsStatus'
        },
        {
          headerName: this.$t('Currency'),
          field: 'currency',
          width: 110,
          hide: false,
          contentType: 'chip',
          contentOptions: window.getEnumCurrencies(),
          cellRendererFramework: 'genericCellRendererContent'
        },
        {
          headerName: this.$t('CustomerFee'),
          field: 'customerFee',
          width: 130,
          hide: false,
          valueFormatter: currencyFormatterWithDollar,
          cellRendererFramework: 'genericCellRendererContent'
        },
        {
          headerName: this.$t('ProviderFee'),
          field: 'providerFee',
          width: 135,
          hide: false,
          valueFormatter: currencyFormatterWithDollar,
          cellRendererFramework: 'genericCellRendererContent'
        },
        {
          headerName: this.$t('Rate'),
          field: 'rate',
          width: 100,
          hide: true
        },
        {
          headerName: this.$t('ProviderName'),
          field: 'providerName',
          width: 130,
          hide: false
        },
        {
          headerName: this.$t('MethodName'),
          field: 'providerMethodName',
          width: 130,
          hide: false
        },
        {
          headerName: this.$t('CreatedDate'),
          field: 'createdDate',
          width: 160,
          hide: false,
          valueFormatter: dateFormatter
        },
        {
          headerName: this.$t('Note'),
          field: 'note',
          width: 200,
          hide: false
        }
      ]
    },
    validateForm () {
      return !this.errors.any()
    },
    usersData () {
      return this.data_local
    }
  },
  created () {
    if (!moduleTransactionMng.isRegistered) {
      this.$store.registerModule('TransactionMng', moduleTransactionMng)
      moduleTransactionMng.isRegistered = true
    }
    this.fetch_transaction_data()
  }
}
</script>
